import { Flex, Box, useMatchBreakpointsContext, Card, Text } from "@pancakeswap/uikit"
import { BaseSwapGradient } from "components/GradientText"
import { useShowRoute } from "state/user/hooks"
import { useSwapQuote } from "state/swap/hooks"
import { useCurrency } from "hooks/Tokens"
import { useSwapState } from "state/swap/hooks"
import { Field } from 'state/swap/actions'
import { useUserSlippageTolerance } from "state/user/hooks"
import styled from "styled-components"


export const BodyWrapper = styled(Card)`
  margin-top: 20px;
  padding: 0.5rem; 
  border: none; 
  border-radius: 18px; 
  margin-left: auto; 
  margin-right: auto; 

  background: none; 
  backdrop-filter: blur(24px); 
  box-shadow: -4px 0 8px -1px #34a7e7, 4px 0 8px -1px #0154fe; 
  width: 95%;

 
  @media (min-width: 1250px) {
    max-width: 600px; 
    margin-left: 12px; 
    box-shadow: -2px 0 2px -1px #34a7e7, 2px 0 2px -1px #0154fe; 
    border: 1px solid; 
    border-color: #34a7e7; 

  }
`

const RouteView = () => {
  const isDesktop = useMatchBreakpointsContext()
  const [showRoute] = useShowRoute()
  const {
    typedValue,
    [Field.INPUT]: { currencyId: inputCurrencyId },
    [Field.OUTPUT]: { currencyId: outputCurrencyId },
  } = useSwapState()
  const inputCurrency = useCurrency(inputCurrencyId)
  const outputCurrency = useCurrency(outputCurrencyId)
  const [allowedSlippage] = useUserSlippageTolerance()
  const swapData = useSwapQuote(inputCurrency, outputCurrency, typedValue, allowedSlippage)

  return (
    <>
      {showRoute && (
          <BodyWrapper>
            <Box>
              <Flex flexDirection="column" alignItems="center" width="100%" padding="4px" mr={18}>
                <BaseSwapGradient textTransform="uppercase" fontSize={isDesktop ? '32px' : '18px'}>
                  Swap Route
                </BaseSwapGradient>
              </Flex>
              {swapData?.data?.pathVizImage ? (
                <img src={swapData.data.pathVizImage} alt="swap-path" />
              ) : (
                <Text
                  textTransform="uppercase"
                  textAlign="center"
                  fontWeight="500"
                  fontSize={isDesktop ? '14px' : '14px'}
                >
                  Enter your swap to see its optimal route!
                </Text>
              )}
            </Box>
          </BodyWrapper>

      )}
    </>
  )
}

export default RouteView